import { navigate as gatsbyNavigate } from "gatsby"
import { navigate as routerNavigate } from "@reach/router"

const isAccountPath = path => path === "/createaccount" || path === "/createaccount/"

export const navigateAuth = (to, options = {}) => {
  if (typeof window === "undefined") return Promise.resolve()
  let target
  try {
    target = new URL(to, window.location.origin)
    if (target.origin !== window.location.origin) throw new Error("external_auth_target")
  } catch (e) {
    target = new URL("/proxies", window.location.origin)
  }

  const withinAccount = isAccountPath(window.location.pathname) && isAccountPath(target.pathname)
  const destination = (withinAccount ? window.location.pathname : target.pathname) + target.search + target.hash
  // A query transition uses the component already on screen. Gatsby 2's
  // service-worker-update branch reloads only pathname, dropping the form query
  // and component state. Reach is already used by this app's layout/router.
  if (withinAccount) return routerNavigate(destination, options)

  if (window.___swUpdated) {
    // Keep Gatsby's version-change reload for a different page, with its query.
    options.replace ? window.location.replace(destination) : window.location.assign(destination)
    return Promise.resolve()
  }
  return gatsbyNavigate(destination, options)
}
